module.exports = __webpack_public_path__ + "img/xddqsea-currency-guide-en.0e7ffbba.png";